import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation  } from 'react-router-dom'; 
import { useForm , useWatch} from 'react-hook-form'; // <-- Import `useForm` here
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from "react-icons/md"; // <-- NEW: Import for the close icon
import { BsBank } from "react-icons/bs";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { FaRegBuilding } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { MdAccountCircle } from "react-icons/md";
import {Layout, CustomerProfile, CustomerConfig} from '../../../../components';
import {handleApi,findRecordSafe} from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import '../styles/style.css';

const NewCustomer = () => {
  const location = useLocation();
  const customers = location.state?.customers || [];
  const { reset, control, register, handleSubmit, formState: { errors }, resetField } = useForm();
  const [customer, setCustomer] = useState({});
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]); // <--  State to store regions
  const [cities, setCities] = useState([]); // <--  State to stor cities
  const [isLoading, setIsLoading] = useState(false);
  const [displayImg, setDisplayImg] = useState(''); 
  const [imgType, setImgType] = useState('');
  const { userData, companyProfile, bank, currentColor, actionCount, setActionCount } = useContext(AppContext);

  //fetch categories and uoms when the component mounts
  const selectedCountryId = 133;
  useEffect(() => {
    fetchCountries();
    fetchRegions(selectedCountryId);
    fetchCities(selectedCountryId);
  }, []);


  // const selectedCountryId = useWatch({control,name: 'country',}); //Watch country field for changes
  // const selectedRegionId = useWatch({ control, name: 'region' }); //Watch region field for changes
  
  //const selectedRegionId = useWatch({ control, name: 'region' }); //Watch region field for changes

    useEffect(() => { // Fetch regions when a country is selected
      if (selectedCountryId) { 
        fetchRegions(selectedCountryId);// If a country is selected, fetch its regions
        // resetField('region');  // Reset the region field to prevent stale data
        resetField('city');  // Reset the region field to prevent stale data
      } else {setRegions([]); } // Clear regions if no country is selected
    }, [selectedCountryId, resetField]);

    useEffect(() => {
      if (selectedCountryId) {
          fetchCities(selectedCountryId);
          resetField('city');  // Reset the region field to prevent stale data
      } else {
          setCities([]);
      }
  }, [selectedCountryId, resetField]);
  
  
  // Reset the form when `customer` state changes (initial or after submit)
  useEffect(() => {reset(customer); }, [customer, reset]);
  
  const fetchCountries = async () => {
    const apiEndpoint = 'countries';
    const apiMethod = 'GET';
    const parameters = {};
    setIsLoading(true);
    const params = {};
    try {
      const response = await handleApi(apiEndpoint, params, userData, apiMethod, parameters);
      if (response.error) {
        console.error('Error fetching customer categories', response.errorMessage);
        return; // Exit function to avoid further processing
      }
      const { status, statusText } = response;
      if (status === 200) {
        const fetchedCountries = response.data; // fetched categories
        //format Customer categories  for select options
        const transformedCountries = fetchedCountries.map(country => ({
          value: country.id,
          label: country.name
        }));
        // Now update the state with the transformed data
        setCountries(transformedCountries);
      } else {
        console.error(`Error ${status}: ${statusText}`); // Handle non-200 responses
      }
    } catch (error) {
      console.error(error.message || 'An unexpected error occurred.'); // Handle unexpected errors
    } finally {setIsLoading(false);}
  };

  
  const fetchRegions = async (selectedCountryId) => {
    const apiEndpoint = 'regions';
    const apiMethod = 'GET';
    const parameters = {country_id:selectedCountryId};
    setIsLoading(true);
    const data = {};
    try {
      const response = await handleApi(apiEndpoint, data, userData, apiMethod, parameters);
      if (response.error) {
        console.error('Error fetching Regions ', response.errorMessage);
        return; // Exit function to avoid further processing
      }
      const { status, statusText } = response;
      if (status === 200) {
        const fetchedRegions = response.data; // fetched categories
        //format uoms  for select options
        const transformedRegions = fetchedRegions.map(region => ({
          value: region.id,
          label: region.name
        }));
        setRegions(transformedRegions);  // Now update the state with the transformed data
      } else {console.error(`Error ${status}: ${statusText}`);   }// Handle non-200 responses
    
    } catch (error) {console.error(error.message || 'An unexpected error occurred.'); // Handle unexpected errors
    } finally {setIsLoading(false);}
  };

  const fetchCities = async (selectedCountryId) => {
    const apiEndpoint = 'districts';
    const apiMethod = 'GET';
    const parameters = {country_id:selectedCountryId};
    setIsLoading(true);
    const data = {};
    try {
      const response = await handleApi(apiEndpoint, data, userData, apiMethod, parameters);
 
      if (response.error) {
        console.error('Error fetching Regions ', response.errorMessage);
        return; // Exit function to avoid further processing
      }
      const { status, statusText } = response;

      if (status === 200) {
        const fetchedCities= response.data; // fetched categories
        //format uoms  for select options
        const transformedCities = fetchedCities.map(city => ({
          value: city.id,
          label: city.name
        }));
        setCities(transformedCities); // Now update the state with the transformed data
      } else {console.error(`Error ${status}: ${statusText}`);  }// Handle non-200 responses
     
    } catch (error) {console.error(error.message || 'An unexpected error occurred.'); // Handle unexpected errors
    } finally {setIsLoading(false);}
  };
  
  


  // Handle the cancel action
  const handleCancel = () => {
    reset();  // Reset the form state to its initial default values
    setCustomer({}); // Reset other component state as needed
  };
  const navigate = useNavigate(); 

  // handle closing the page
  const handleClosePage = () => {navigate(-1);};// Navigate back to the previous page
  const handleChange = (event) => {const { name, value } = event.target;};
  
  const handleCustomerFormSubmit = async (dataFromForm) => {
    console.log('dataFromForm sir ',dataFromForm)
    // Check if customer already exists using the reusable findRecordSafe
    const existingCustomer = findRecordSafe(dataFromForm, customers, ['name']);

    
    if (existingCustomer) {
      toast.error(`Customer "${dataFromForm.name || 'Unknown'}" already exists.`);
      return; // Stop submission
    }
  
    // Safe debugging: stringify form data
    try {
      console.log(
        'Form data received from react-hook-form (safe stringify):',
        JSON.stringify(dataFromForm, null, 2)
      );
    } catch (e) {
      console.error('Failed to stringify `dataFromForm`. Circular reference found:', dataFromForm);
      toast.error('Form data is corrupted. Check the console for details.');
      setIsLoading(false);
      return;
    }
  
    

    const { create_uid, update_date, ...filteredData } = dataFromForm; // Remove fields not needed in payload
    const payload = { ...filteredData, is_customer: 1 }; // add fields  needed in payload
  
    // Safe debugging: stringify final payload
    try {
      console.log('Final payload to send to API (safe stringify):', JSON.stringify(payload, null, 2));
    } catch (e) {
      console.error('Final payload has a circular reference. Inspect the object below.', payload);
      toast.error('The final payload is corrupted. Check the console for details.');
      setIsLoading(false);
      return;
    }
  
    const apiMethod = payload.id ? 'PUT' : 'POST';
    const parameters = payload.id ? { id: payload.id } : {};
  
    setIsLoading(true);
  
    try {
      const response = await handleApi('Customers', payload, userData, apiMethod, parameters);
      if (response.status === 200 || response.status === 201) {
        toast.success('Customer saved successfully!');
        handleCancel(); // Reset form
      } else {toast.error(`Error saving customer: ${response.statusText || 'An unknown error occurred'}`);}
    } catch (error) { toast.error('Error saving customer: ' + error.message);
    } finally {
      setActionCount(actionCount + 1);
      setIsLoading(false);
    }
  };
  
  return (
    <Layout>
      <div className="m-1 sm:m-2">
        {/* New flex container for the title and close button */}
        <div className="relative flex justify-between items-center">
          <h1 className="text-center font-bold flex-grow">NEW CUSTOMER</h1>
          <button
            onClick={handleClosePage}
            className="p-1 rounded-lg text-red-400 bg-white hover:bg-gray-50 hover:text-gray-600"
          >
            <MdOutlineCancel color={currentColor} size={30} />
          </button>
        </div>
        {/* Tab Buttons */}
        <ToastContainer position="top-center" autoClose={2000} />
        {isLoading ? (
          <div className="flex items-center flex-col py-6">
            <Audio height="80" width="80" radius="9" color={currentColor} ariaLabel="loading" />
            <p className="mt-2 text-white">Loading. Please wait...</p>
          </div>
        ) : (
          <div className="bg-whitey p-2 sm:p-4 my-4 my-auto mx-auto max-w-[80%] rounded-xl shadow-2xl">
            <div className="mx-auto border-b border-gray-400 bg-gray-500 transition-all duration-200 cursor-pointer rounded-xl shadow-2xl p-8">
              <CustomerProfile
                  fields={CustomerConfig}
                  control={control}
                  register={register}
                  onChange={handleChange}
                  countries={countries} // Pass categories to CustomerProfile
                  regions={regions} // Pass the regions state
                  cities={cities}   // Pass the cities state
                  onSubmit={handleSubmit(handleCustomerFormSubmit)}
                  customerData={customer} // Ensure customerData is passed correctly for initial values
                  onCancel={handleCancel} // Pass the proper clearing function here
                  errors={errors} // <-- Pass `errors` down
                  reset={reset} // <-- NEW: Pass the `reset` function from `useForm`
                  isLoading={isLoading}
                />
              </div>
          </div>
        )}
      </div>
    </Layout>
  );
};
export default NewCustomer;